import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const getMyOrder = async (payload) => {
  try {
    console.log(payload, 'hining');

    const response = await APIs.get(
      `/get_my_order/${payload?.status}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleOrder = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_order/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editOrder = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_order/${payload?.orderId}`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAddressOrder = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_address_order/${payload?.orderId}`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllStatusAdvancedCount = async () => {
  try {
    const response = await APIs.get(`/get_a_user_advanced_status_count_order`);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllUserOrderCount = async () => {
  try {
    const response = await APIs.get(
      `/get_a_user_advanced_total_status_count_order`
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const userOrderServices = {
  getMyOrder,
  getSingleOrder,
  editOrder,
  editAddressOrder,
  getAllStatusAdvancedCount,
  getAllUserOrderCount,
};

export default userOrderServices;
